"use client";

import { isNativeApp } from "@/lib/nativePlatform";

function canUseWebShare() {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof navigator.share === "function" &&
    window.matchMedia?.("(pointer: coarse)")?.matches
  );
}

export async function shareWithSystem(payload, { dialogTitle = "Share Sproutly" } = {}) {
  if (!payload?.url) return false;

  if (isNativeApp()) {
    try {
      const { Share } = await import("@capacitor/share");
      const canShare = await Share.canShare();
      if (canShare?.value) {
        await Share.share({
          title: payload.title,
          text: payload.text,
          url: payload.url,
          dialogTitle,
        });
        return true;
      }
    } catch (err) {
      console.debug("Capacitor Share failed", err);
    }
  }

  if (canUseWebShare()) {
    try {
      await navigator.share({
        title: payload.title,
        text: payload.text,
        url: payload.url,
      });
      return true;
    } catch (err) {
      console.debug("navigator.share failed", err);
    }
  }

  return false;
}

